import React from "react";
import { Box, Stack, Typography } from "@mui/material";

import historyAndWorkflowImage from "src/shared/assets/historyAndWorkflow.png";

export const HistoryAndWorkflow: React.FC = () => {
  return (
    <Stack
      width={1}
      justifyContent="flex-start"
      alignItems="center"
      direction="column"
      gap={1}
    >
      <Stack
        width={1}
        direction="row"
        justifyContent="center"
        alignItems="center"
        gap={1}
        sx={{
          flexWrap: {
            sm: "nowrap",
            xs: "wrap",
          },
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          History
        </Typography>
        <Typography
          color="text.secondary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          and
        </Typography>
        <Typography
          color="primary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          Agentic workflow
        </Typography>
        <Typography
          color="text.secondary"
          variant="h5"
          textTransform="uppercase"
          fontWeight={300}
        >
          integration
        </Typography>
      </Stack>

      <Typography
        maxWidth={0.7}
        color="text.primary"
        variant="body1"
        textAlign="center"
        sx={{
          fontSize: {
            sm: "1rem",
            xs: "0.875rem",
          },
        }}
      >
        Access your entire generation history and trigger powerful n8n agentic
        workflows on-the-fly, transforming a simple shortcut into a fully
        automated task
      </Typography>

      <Box width={1}>
        <img
          width="100%"
          src={historyAndWorkflowImage}
          alt="historyAndWorkflowImage"
        />
      </Box>
    </Stack>
  );
};
